module.exports = __webpack_public_path__ + "img/VP-Standard_Overview-EVA_2.1ccad125.jpg";